import { createRouter, createWebHashHistory } from "vue-router";
import main from "../views/main.vue";
import { ElNotification } from "element-plus";

const routes = [
	{
		path: "/",
		name: "main",
		component: main,
		children: [
			{
				path: "/",
				name: "home",
				component: () => import("../views/home/home.vue"),
			},
			{
				path: "/defect",
				name: "defect",
				component: () => import("../views/defect/defect.vue"),
			},
			{
				path: "/rm_wait",
				name: "rm_wait",
				component: () => import("../views/defect/rm_wait.vue"),
			},
			{
				path: "/rm_all",
				name: "rm_all",
				component: () => import("../views/defect/rm_all.vue"),
			},
			{
				path: "/test_rule",
				name: "test_rule",
				component: () => import("../views/defect/test_rule.vue"),
			},
			{
				path: "/test_doc",
				name: "test_doc",
				component: () => import("../views/defect/test_doc.vue"),
			},
			{
				path: "/test_case",
				name: "test_case",
				component: () => import("../views/defect/test_case.vue"),
			},
			{
				path: "/do_plan",
				name: "do_plan",
				component: () => import("../views/defect/do_plan.vue"),
			},
			{
				path: "/do_report",
				name: "do_report",
				component: () => import("../views/defect/do_report.vue"),
			},
			{
				path: "/do_newdefect",
				name: "do_newdefect",
				component: () => import("../views/defect/do_newdefect.vue"),
			},
			{
				path: "/config_shortcut",
				name: "config_shortcut",
				component: () => import("../views/defect/config_shortcut.vue"),
			},
			{
				path: "/config_flow",
				name: "config_flow",
				component: () => import("../views/defect/config_flow.vue"),
			},
			{
				path: "/config_func",
				name: "config_func",
				component: () => import("../views/defect/config_func.vue"),
			},
			{
				path: "/dict_severity",
				name: "dict_severity",
				component: () => import("../views/defect/dict_severity.vue"),
			},
			{
				path: "/dict_priority",
				name: "dict_priority",
				component: () => import("../views/defect/dict_priority.vue"),
			},
			{
				path: "/dict_source",
				name: "dict_source",
				component: () => import("../views/defect/dict_source.vue"),
			},
			{
				path: "/dict_type",
				name: "dict_type",
				component: () => import("../views/defect/dict_type.vue"),
			},
			{
				path: "/dict_stage",
				name: "dict_stage",
				component: () => import("../views/defect/dict_stage.vue"),
			},
			{
				path: "/dict_percent",
				name: "dict_percent",
				component: () => import("../views/defect/dict_percent.vue"),
			},
			{
				path: "/dict_scope",
				name: "dict_scope",
				component: () => import("../views/defect/dict_scope.vue"),
			},
			{
				path: "/dict_FixDifficulty",
				name: "dict_FixDifficulty",
				component: () => import("../views/defect/dict_FixDifficulty.vue"),
			},
			{
				path: "/dict_testtype",
				name: "dict_testtype",
				component: () => import("../views/defect/dict_testtype.vue"),
			},
			{
				path: "/dict_status",
				name: "dict_status",
				component: () => import("../views/defect/dict_status.vue"),
			},
			{
				path: "/dict_testlevel",
				name: "dict_testlevel",
				component: () => import("../views/defect/dict_testlevel.vue"),
			},
			{
				path: "/config_right",
				name: "config_right",
				component: () => import("../views/defect/config_right.vue"),
			},
			{
				path: "/qxbmlb",
				name: "qxbmlb",
				component: () => import("../views/pzx/qxbmlb.vue"),
			},
			{
				path: "/qxyhlb",
				name: "qxyhlb",
				component: () => import("../views/pzx/qxyhlb.vue"),
			},
		],
	},
	{
		path: "/login",
		name: "login",
		component: () => import("../views/login/login.vue"),
	},
	{
		path: "/404",
		name: "404",
		component: () => import("@/views/noPage/404.vue"),
	},
	{
		path: "/linkLog",
		name: "linkLog",
		component: () => import("@/views/noPage/linkLog.vue"),
	},
	{
		path: "/:catchAll(.*)",
		redirect: "/404",
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

const whiteList = ["login", "linkLog"];
router.beforeEach((to, from, next) => {
	if (localStorage.getItem("token")) {
		next();
	} else {
		if (whiteList.indexOf(to.name) !== -1) {
			next();
		} else {
			ElNotification({
				title: "系统提示",
				message: "未登录，请登录",
				type: "error",
				duration: 3000,
			});
			next({ path: "/login" });
		}
	}
});
export default router;
